<template>
      <div>
        <b-icon v-if="data.state == 1" icon="check" variant="success" animation="throb" font-scale="8" />
        <b-icon v-if="data.state == 0" icon="exclamation-triangle" variant="warning" animation="throb" font-scale="8" />
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <p v-if="data.state == 1"> {{data.product.name}} ürününü aktif etmek istediğinden emin misin ?</p>
        <p v-if="data.state == 0"> {{data.product.name}} ürününü pasif etmek istediğinden emin misin ?</p>
   </div>
</template>

<script>
    export default {
        name: "SetStateAccount",
        //
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function
        },
        methods:{
            getState(){
                if (this.data.state === 1){
                    return true
                } else {
                    return false
                }
            }
        },
        watch: {
            save: async function(data){
            if(data){
                let data = {
                    id: this.data.product.id,
                    state: this.getState(),
                }
                await this.$store.dispatch('setProductStatus', data)
                if(this.$store.getters.getAddressStatus.status == "Success"){
                    await this.$store.dispatch('listProducts',this.data.params )
                    this.saveState(false)
                    this.modalEvent(false)
                }else{
                    this.errMsg = this.$store.getters.getAddressStatus.message
                }
            }
                this.saveState(false)
                this.modalEvent(false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/SetStateProduct.vue